import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { center } from '@turf/turf';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $ABGradient,
  $activeLayer,
  $worldPolygons,
} from '../../../models/ABMarketsModel/index.js';

export const formABDynamicBuckets = (buckets, colors, property) => {
  const formatedBuckets = [];
  buckets.forEach((item, index) => {
    if (index === 0) return;
    if (index === 1) {
      formatedBuckets.push(['<', ['get', property], item]);
    } else {
      let value = item;
      if (index === buckets.length - 1) {
        value = item + 1;
      }
      formatedBuckets.push([
        'all',
        ['>', ['get', property], buckets[index - 1]],
        [
          '<=',
          ['get', property],
          index === buckets.length - 1 ? value + 1 : value,
        ],
      ]);
    }
  });

  const result = ['case', ['==', ['get', 'name'], 'Kazakhstan'], 'green'];

  formatedBuckets.forEach((item, index) => {
    result.push(item, colors[index]);
  });
  result.push('#dee2e8');
  return result;
};

// const gradientProp = [
//   'case',
//   ['==', ['get', 'name'], 'Kazakhstan'],
//   'green',
//   ['<=', ['get', 'tariff'], 5],
//   '#b6e0f2',
//   ['all', ['>', ['get', 'tariff'], 5], ['<=', ['get', 'tariff'], 10]],
//   '#b5d1f1',
//   ['all', ['>', ['get', 'tariff'], 10], ['<=', ['get', 'tariff'], 15]],
//   '#ffe5c7',
//   ['all', ['>', ['get', 'tariff'], 15], ['<=', ['get', 'tariff'], 20]],
//   '#1f5da4',
//   ['all', ['>', ['get', 'tariff'], 20], ['<=', ['get', 'tariff'], 25]],
//   '#002b5b',
//   ['all', ['>', ['get', 'tariff'], 25], ['<=', ['get', 'tariff'], 50]],
//   '#001a38',
//   ['>', ['get', 'tariff'], 50],
//   '#4d0006',
//   '#dee2e8',
// ];

function WorldPolygons() {
  const mapLoaded = useUnit($mapLoaded);
  const worldPolygons = useUnit($worldPolygons);
  const { buckets, colors } = useUnit($ABGradient);
  const activeLayer = useUnit($activeLayer);

  const createLayer = (update) => {
    const worldData = {
      type: 'FeatureCollection',
      features: worldPolygons,
    };

    const gradientProp = formABDynamicBuckets(buckets, colors, activeLayer);

    if (update) {
      window.map.getSource('world_source').setData(worldData);
      window.map.setPaintProperty('world_polygons', 'fill-color', gradientProp);
    } else {
      if (!window.map.getSource('world_source')) {
        window.map.addSource('world_source', {
          type: 'geojson',
          data: worldData,
        });
      }

      if (!window.map.getSource('world_points_source')) {
        window.map.addSource('world_points_source', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [],
          },
        });
      }

      if (!window.map.getSource('world_line_source')) {
        window.map.addSource('world_line_source', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [],
          },
        });
      }

      if (!window.map.getLayer('world_layer')) {
        window.map.addLayer({
          id: 'world_polygons',
          type: 'fill',
          source: 'world_source',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': 0.5,
          },
        });
      }

      const popup = new mapboxgl.Popup({ closeButton: false });
      let country = '';
      window.map.on('mousemove', 'world_polygons', (e) => {
        let html = `<div>
                <div style="color: black; font-weight: bold">Партнер: ${
                  e.features[0].properties.name
                }</div>
                <div style="color: black; font-weight: bold;">Примененный тариф(год): ${
                  e.features[0].properties.tariff || 0
                }%</div>
                <div style="color: black; font-weight: bold;">Объем импорта: ${
                  e.features[0].properties.cost_all || 0
                }</div>
                <div style="color: black; font-weight: bold;">Объем импорта из Казахстана: ${
                  e.features[0].properties.cost || 0
                }</div>
              </div>`;
        if (e.features[0].properties.name === 'Казахстан') {
          html = `<div style="color: black; font-weight: bold">${e.features[0].properties.name}</div>`;
        }
        if (country !== e.features[0].properties.name) {
          popup.trackPointer().setHTML(html).addTo(window.map);
          country = e.features[0].properties.name;
        }
      });
      window.map.on('mouseleave', 'world_polygons', () => {
        country = '';
        popup.remove();
      });

      const KzCenterPoint = {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [66.9232177734375, 48.01937499678047],
        },
      };

      window.map.on('click', 'world_polygons', (e) => {
        const currentCenter = center(e.features[0]);
        if (window.innerWidth < 500) {
          let html = `<div> 
                <div style="color: black; font-weight: bold">Партнер: ${
                  e.features[0].properties.name
                }</div>
                <div style="color: black; font-weight: bold;">Примененный тариф(год): ${
                  e.features[0].properties.tariff || 0
                }%</div>
                <div style="color: black; font-weight: bold;">Объем импорта: ${
                  e.features[0].properties.cost_all || 0
                }</div>
                <div style="color: black; font-weight: bold;">Объем импорта из Казахстана: ${
                  e.features[0].properties.cost || 0
                }</div>
              </div>`;
          if (e.features[0].properties.name === 'Казахстан') {
            html = `<div style="color: black; font-weight: bold">${e.features[0].properties.name}</div>`;
          }
          // if (country !== e.features[0].properties.name) {
          popup.setLngLat(e.lngLat).setHTML(html).addTo(window.map);
          //   country = e.features[0].properties.name;
          // }
        }
        if (e.features[0].properties.name === 'Казахстан') {
          window.map.getSource('world_points_source').setData({
            type: 'FeatureCollection',
            features: [],
          });
          window.map.getSource('world_line_source').setData({
            type: 'FeatureCollection',
            features: [],
          });
        } else {
          window.map.getSource('world_points_source').setData({
            type: 'FeatureCollection',
            features: [KzCenterPoint, currentCenter],
          });
          window.map.getSource('world_line_source').setData({
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                properties: [],
                geometry: {
                  type: 'LineString',
                  coordinates: [
                    KzCenterPoint.geometry.coordinates,
                    currentCenter.geometry.coordinates,
                  ],
                },
              },
            ],
          });
        }
      });
    }
  };

  useEffect(() => {
    if (mapLoaded && worldPolygons && buckets.length > 0) {
      if (window.map.getLayer('world_polygons')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, worldPolygons, buckets]);

  return null;
}

export default WorldPolygons;
